<script lang="ts">
    import { _ } from "svelte-i18n"
    import { cart, cartOverlay, login } from "../../store"
    import CartItems from "./CartItems.svelte"

    export let checkoutButton = true
    export let invalidProductsInCart = false

    let innerWidth: number

    $: invalidProductsInCart = $login && !!$cart?.filter((c) => c.product.no_dealers).length

    $: normalCart = $login ? $cart.filter((i) => !i.product.price_net_dealer_is_fixed) : $cart
    $: fixedPriceCart = $login ? $cart.filter((i) => i.product.price_net_dealer_is_fixed) : []
</script>

<svelte:window bind:innerWidth />

<div class="cart">
    {#if $cart?.length}
        {#if $login}
            <h3>Produkte mit Ihren individuellen Konditionen</h3>
            <section>
                <div class="dealerInfo">
                    {$_("cart.dealer-conditions-info")}
                    <br />
                    <br />
                </div>
            </section>
        {/if}
        <CartItems cartItems="{normalCart}" />
        {#if $login}
            <br />
            <br />
            <h3>Produkte mit festen Preisen</h3>
            <CartItems cartItems="{fixedPriceCart}" />
            <br />
        {/if}
        {#if invalidProductsInCart}
            <div style="color: darkred;">
                <br />
                <b>Es sind ungültige Produkte im Warenkorb.</b><br />
                Nicht alle Produkte können als Händler bestellt werden. Bitte entfernen Sie diese.
            </div>
        {:else if checkoutButton}
            <div style="display: flex; justify-content: space-between">
                <div>
                    <!-- svelte-ignore a11y-invalid-attribute -->
                    <a
                        href="#"
                        class="btn btn-secondary"
                        on:click|preventDefault="{() => {
                            $cartOverlay = false
                        }}">{$_("cart.continue_shopping")}</a
                    >
                </div>
                <div>
                    <a
                        href="/checkout{$login ? '/dealer' : ''}"
                        class="btn btn-secondary"
                        on:click="{() => {
                            if (innerWidth < 1024) {
                                // close on mobile devices
                                $cartOverlay = false
                            }
                        }}">{$_("cart.checkout now")}</a
                    >
                </div>
            </div>
        {/if}
    {:else}
        <div class="empty_cart">
            {$_("cart.cart-is-empty")}<br />
            <a href="/">{$_("cart.shopping-now")}</a>
        </div>
        <!-- svelte-ignore a11y-invalid-attribute -->
        <a
            href="#"
            class="btn btn-secondary"
            on:click|preventDefault="{() => {
                $cartOverlay = false
            }}">{$_("cart.continue_shopping")}</a
        >
    {/if}
</div>

<style lang="less">
    @import "../../css/variables.less";

    .empty_cart {
        .flex();
        align-items: center;
        justify-content: center;
        height: 400px;
        flex-direction: column;
    }
    .cart :global {
        .variant {
            font-size: 0.8em;
        }
        .product {
            &.invalid {
                filter: drop-shadow(2px 4px 6px darkred);
            }

            border-bottom: dotted 1px #ccc;
            .flex();
            justify-content: center;
            flex-wrap: wrap;
            margin-bottom: 20px;
            padding-bottom: 20px;
            @media @mobile {
                flex-wrap: nowrap;
            }
            .image {
                position: relative;
                .flex();
                align-items: center;
                justify-content: center;
                width: 100%;
                height: auto;
                background: var(--background);
                padding: 20px;
                margin-bottom: 15px;
                a {
                    display: block;
                    width: 100%;
                    height: 50vw;
                    @media @mobile {
                        height: auto;
                    }
                }
                @media @mobile {
                    width: 100px;
                    height: 80px;
                    margin-right: 15px;
                }
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
            .text {
                width: 60%;
                .title {
                    font-size: 1.2rem;
                    font-weight: 700;
                }
                .artnum {
                    font-size: 0.7rem;
                }
            }
            .price {
                text-align: right;
                width: 40%;
                font-size: 1rem;
            }
            .buttons {
                min-width: 140px;
                margin-top: 20px;
                .flex();
                align-items: center;
                justify-content: flex-start;
                flex-wrap: wrap;
                .btn {
                    font-size: 0.8rem;
                    .flex();
                    max-width: 150px;
                    align-items: center;
                    justify-content: center;
                    &:nth-child(2) {
                        @media (max-width: 1100px) {
                            margin-right: 0;
                        }
                    }
                    &:last-child {
                        padding: 5px 15px;
                        margin-right: 0;
                        @media (max-width: 1100px) {
                            width: 100%;
                            text-align: center;
                            margin-top: 10px;
                        }
                        @media (max-width: 550px) {
                            width: auto;
                            margin-top: 0px;
                        }
                        @media (max-width: 420px) {
                            width: 100%;
                            margin-top: 10px;
                        }
                    }
                }
            }
            .counter {
                margin-right: 30px;
                display: flex;
                justify-content: center;
                align-items: center;

                button {
                    border: none;
                    background: none;
                    font-size: 24px;
                    cursor: pointer;
                    width: 30px;
                    font-weight: 700;
                }
                .nr {
                    font-weight: 700;
                    display: inline-block;
                    width: 30px;
                    text-align: center;
                    font-size: 1rem;
                }
            }
        }
        .result {
            > section > div {
                .flex();
                justify-content: space-between;
            }
            section {
                border-bottom: dotted 1px #ccc;
                padding-bottom: 10px;
                margin-bottom: 10px;
                .sum1 .value {
                    font-weight: 700;
                }
                .small {
                    font-size: 0.7rem;
                }
                .sum2 .value {
                    font-weight: 700;
                    font-size: 1.2rem;
                    color: var(--primary);
                    @media @desktop {
                        font-size: 1.4rem;
                    }
                }
            }
        }
    }
</style>
